import React, { Component, Fragment } from "react";
import { connect, batch } from "react-redux";
//Bootstrap component
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";

// Component
import SingleSelectResponse from "./SingleSelectResponse/SingleSelectResponse";
import SingleSelectDropDown from "./SingleSelectResponse/SingleSelectDropDown";
import SingleSelectSliderResponse from "./SingleSelectResponse/SingleSelectSliderResponse";
import SingleSelectImageResponse from "./SingleSelectResponse/SingleSelectImageResponse";
import SingleSelectTilesResponse from "./SingleSelectResponse/SingleSelectTilesResponse";

import ItemSection from "../../Section/ItemSection";

import {
  processResponse,
  processItemResponse,
} from "../../../../utilities/processResponse";

//Assets
import "../SingleSelectItem/SingleSelectItem.css";

// Actions
import {
  getQuestionList,
  resetSingleItemSlider,
} from "../../../../actions/SurveyAction";

import { isMobile, isTablet } from 'react-device-detect';
class SingleSelectItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sliderValue:null,
            undoIcon:false,
            naCheck:false,
            resetCheckedValue:null,
			width: window.innerWidth,
			height: window.innerHeight
    };

        this.restoreSingleItemArr = [];
    }

	componentDidMount() {
		this.updateDimensions();
		window.addEventListener("resize", this.updateDimensions.bind(this));
		var self = this;   
		if ('onorientationchange' in window) {
			window.addEventListener("orientationchange", function() {
				self.setState({   
					orientation: !self.state.orientation
				})
				console.log( "change orientation");
				//window.location.reload()
			}, false);
		}
	}

	componentDidUpdate(prevProps, nextProps) {
        var questionId = this.props.scrollToQuestionId;

        if (questionId !== null) {
            if (this.props.scrollToQuestionId !== prevProps.scrollToQuestionId) {
                this.scrollToQuestion(questionId);
            }
		}

		if(nextProps == this.props){
			console.log("single select");
            return true
        } else {
            return false
        }

	}

	updateDimensions() {
		if (window.innerWidth < 500) {
			this.setState({ width: 450, height: 102 });
		} else {
			let update_width = window.innerWidth - 100;
			let update_height = Math.round(update_width / 4.4);
			this.setState({ width: update_width, height: update_height });
		}
    }

    resetAllSingleItem = (event, configuration, rateeKey, naType) => {
        const { questionItemList, dispatch } = this.props;

        const { key } = configuration;
        const itemTagKey = key;
        var itemList = questionItemList[key];
        /* Get the element based on question */
        var nodeList = document.getElementsByName(`singleResponse_${itemTagKey}`);
		var nodeDropDown = document.getElementsByClassName(
			`SingleDropDown_${itemTagKey}`
		);
        var singleBox = document.getElementsByName(`singleBox_${itemTagKey}`);

		var sliderThumb = document.getElementsByClassName(
			"rangeslider-horizontal"
		)[0];
		var sliderThumbChild = sliderThumb.getElementsByClassName(
			"rangeslider__handle"
		)[0];

        itemList.filter((items, i) => {

            if (items.key === itemTagKey) {

                if (items.itemResponses.length > 0) {
                    this.restoreSingleItemArr = items.itemResponses;
                    this.setState({undoIcon:true});
                }

                let responseLen = items.itemResponses.length;

                if (naType === "clear" || typeof naType === "boolean") {
                    items.itemResponses = [];
                    items.isAnswer = false;
                    items.isRequired = false;

                    if (naType !== "clear") {
                        this.handleNaDisabled(naType, itemTagKey, questionItemList);
                        items.isNA = naType === false ? false : true;
                    }

                    if (responseLen !== 0) {
                        if (configuration.layoutHints === "slider") {
                            sliderThumbChild.style.background = "#fff";
                        }
                    }

                } else {
                    items.itemResponses = this.restoreSingleItemArr;
                    items.isAnswer = true;
                    items.isRequired = false;
                    items.isNA = false;

                    if (configuration.layoutHints === "slider") {
                        sliderThumbChild.style.background = "#0f5ea0";
                    }
                    this.setState({undoIcon:false});
                }
            }
        });

		var responseId =
			this.restoreSingleItemArr.length > 0 &&
				this.restoreSingleItemArr.hasOwnProperty("responseValue") !== undefined
				? this.restoreSingleItemArr[0].responseValue
				: 0;

        /* Drop Down reset */
        for (const key in nodeDropDown) {
            if (nodeDropDown.hasOwnProperty(key)) {
                const nodeDropDownTemp = nodeDropDown[key];
                nodeDropDownTemp.value = 0;
            }
        }

        /* Single box reset */
		var resetSelectBox = document.getElementById(
			`select_box_${responseId}_${itemTagKey}`
		);

        for (const key in singleBox) {

            if (singleBox.hasOwnProperty(key)) {
                const element = singleBox[key];
                element.classList.remove("active");

                if (typeof naType === "boolean") {

                    if (naType) {
                        element.disabled = true;
                    } else {
                        element.disabled = false;
                    }
                }

                if (naType === "clear") {
                    resetSelectBox.classList.remove("active");
                }

                if (naType === "reset" && responseId !== 0) {
                    resetSelectBox.classList.add("active");
                }
            }
        }

        /* Radio button reset */
		var resetRadioButton = document.getElementById(
			`singleResponse_${responseId}_${itemTagKey}`
		);

        for (const key in nodeList) {
            if (nodeList.hasOwnProperty(key)) {
                const element = nodeList[key];

                if (typeof naType === "boolean") {
                    if (naType) {
                        element.checked = false;
                        element.disabled = true;
                    } else {
                        element.disabled = false;
                    }
                } else if (naType === "clear") {
                    if (element.checked) {
                        element.checked = false;
                    } else {
                        element.disabled = false;
                    }
                } else {
                    if (responseId !== 0) {
                        resetRadioButton.click();
                    }
                }
            }
        }
        // dispatch(getQuestionList(questionItemList));
        batch(() => {
            this.props.dispatch(getQuestionList(questionItemList));
        });
	};

    handleNaDisabled = (naType, itemTagKey, questionItemList) => {
        var scrollDiv = document.getElementById(`ScrollDiv_${itemTagKey}`);

		scrollDiv.style.fontStyle = naType === false ? "normal" : "italic";
		scrollDiv.style.color = naType === false ? "#0f5ea0" : "#8787";
        // this.props.dispatch(getQuestionList(questionItemList));
        batch(() => {
            this.props.dispatch(getQuestionList(questionItemList));
        });
	};

    /**
     * Method to scroll respective element based on id
     *
     * @param { questionId:string }
     *
     */
    scrollToQuestion = (questionId) => {
        var scrollDiv = document.getElementById("ScrollDiv_" + questionId);
		scrollDiv.style.paddingTop = "40px";;
		scrollDiv.scrollIntoView({top:scrollDiv.offsetTop, behavior:"smooth"});
	};

    renderRangeSlider(responseConfiguration, obj) {
		const {
			configuration,
			questionItemList,
			pageInstrumentConfiguration,
			itemResponses,
			itemTempResponses,
			dependencies,
			pageList,
			horizontalAlignment,
			pageNumber,
			activePageKey,
			survey,
			assessmentInfosForDataCollection,
		} = this.props;

		let uniqueId = [
			this.currentRatee.key,
			configuration.key,
			responseConfiguration.response,
		].join(":");

        let buttonGroup = [this.currentRatee.key, configuration.key].join(":");
        let key = this.currentRatee.dataCollectionGuid;
        const { scales } = pageInstrumentConfiguration;
        const scaleResponses = scales[configuration.scaleKey].scaleResponses;
        const renderingHint = scales[configuration.scaleKey].renderingHint;
        const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        return (
			<td key={uniqueId} colSpan="5" className="_multiUserSingleSelectTblCol">
				{configuration.layoutHints === "slider" ? (
					<SingleSelectSliderResponse
						className={configuration.className}
						configuration={configuration.scale}
						key={configuration.key}
						id={configuration.key}
						buttonGroup={configuration.key}
						items={configuration}
						questionItemList={questionItemList}
						rateeKey={key}
						resClass="MultiUserSlider"
					/>
				) : configuration.layoutHints === "singleselectdropdown" ? (
                    <SingleSelectDropDown
                        className={configuration.className}
                        configuration={configuration.scale}
                        key={configuration.key}
                        id={configuration.key}
                        buttonGroup={configuration.key}
                        items={configuration}
                        questionItemList={questionItemList}
                        rateeKey={key}
                        resClass="MultiUserSlider"
						handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
						getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
                    />
				) : (
					<SingleSelectDropDown
                        itemKey={scales[configuration.scaleKey].key}
                        singleSelectItemConfiguration={scales[configuration.scaleKey]}
                        className={scales[configuration.scaleKey].className}
                        configuration={scaleResponses}
                        buttonGroup={buttonGroup}
                        dependencies={dependencies}
                        pageList={pageList}
                        id={uniqueId}
                        survey={survey}
                        activePageKey={activePageKey}
                        pageNumber={pageNumber}
                        items={configuration}
                        // dependencies={dependencies}
                        itemResponses={itemResponses}
                        itemTempResponses={itemTempResponses}
                        handleItemResponse={(itemKey, itemResponsesSet, type, dataGuidId) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuidId)}
                        questionItemList={questionItemList}
                        ratees={assessmentObj}
                        putAllForItemCollection={this.props.putAllForItemCollection}
                        rateeKey={key}
						handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
						getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
                    />
				)}
            </td>
        );
    }

    renderRangeSliderGroup(ratee, me) {
        const { configuration, pageInstrumentConfiguration } = this.props;
        this.currentRatee = ratee;
		this.currentButtonGroup = [this.currentRatee.key, configuration.key].join(
			":"
		);
        const { scales } = pageInstrumentConfiguration;
        const scaleResponses = scales[configuration.scaleKey].scaleResponses;

		return this.renderRangeSlider(configuration, this);
		// return configuration.layoutHints === "slider" || configuration.layoutHints === "singleselectdropdown" && scales != null && scaleResponses != null ? this.renderRangeSlider(configuration, this): this.props.ratees.map(this.renderRangeSlider, this)
    }

	renderSingleSelectItem(ratee, me) {
		const { configuration, pageInstrumentConfiguration } = this.props;
		this.currentRatee = ratee;
		this.currentButtonGroup = [this.currentRatee.key, configuration.key].join(
			":"
		);
		const { scales } = pageInstrumentConfiguration;
		const scaleResponses = scales[configuration.scaleKey].scaleResponses;

		return this.renderSingleItem(configuration, this);
	}

	renderSingleItem = (responseConfiguration, obj) => {
		const {
			configuration,
			questionItemList,
			pageInstrumentConfiguration,
			itemResponses,
			itemTempResponses,
			dependencies,
			pageList,
			horizontalAlignment,
			pageNumber,
			activePageKey,
			survey,
			assessmentInfosForDataCollection,
		} = this.props;

		let uniqueId = [
			this.currentRatee.key,
			configuration.key,
			responseConfiguration.response,
		].join(":");
		let buttonGroup = [this.currentRatee.key, configuration.key].join(":");
		let key = this.currentRatee.dataCollectionGuid;
		const { scales } = pageInstrumentConfiguration;
		const scaleResponses = scales[configuration.scaleKey].scaleResponses;
		const renderingHint = scales[configuration.scaleKey].renderingHint;
		const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

		return (scaleResponses !== undefined && scaleResponses.map(
			(responseConfiguration, i) => {
				return (
					<td className="_multiUserSingleSelectTblCol">
						<SingleSelectResponse
							key={key}
							itemKey={scales[configuration.scaleKey].key}
							singleSelectItemConfiguration={
								scales[configuration.scaleKey]
							}
							className={scales[configuration.scaleKey].className}
							configuration={responseConfiguration}
							pageList={pageList}
							survey={survey}
							activePageKey={activePageKey}
							pageNumber={pageNumber}
							id={responseConfiguration.key}
							buttonGroup={configuration.key}
							items={configuration}
							dependencies={dependencies}
							itemResponses={itemResponses}
							itemTempResponses={itemTempResponses}
							onNextButtonClickTest={(
								num,
								type,
								activePageNumber
							) =>
								this.props.onNextButtonClick(
									num,
									type,
									activePageNumber
								)
							}
							handleItemResponse={(
								itemKey,
								itemResponsesSet,
								type,
								dataGuidId
							) =>
								this.props.handleItemResponse(
									itemKey,
									itemResponsesSet,
									type,
									dataGuidId
								)
							}
							flag={"MultiUser"}
							questionItemList={questionItemList}
							indexKey={i}
							ratees={assessmentObj}
							rateeKey={key}
							horizontalAlignment={horizontalAlignment}
							putAllForItemCollection={
								this.props.putAllForItemCollection
							}
							handleDynamicDependency={(checkboxAnswer,depKey,response,pageDep, reqInd)=>this.props.handleDynamicDependency(checkboxAnswer,depKey,response,pageDep, reqInd)}
							getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
							handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
						/>
					</td>
				);
			}
		)
		)
	}
    /**
     * Method to load spinner image
     *
     */
    renderSpinner = (configuration) => {
		return (
			<i
				className={`fa fa-spinner fa-spin fa_${configuration.key}`}
				style={{ fontSize: "25px", display: "none" }}
			></i>
		);
	};

    /**
     * N/A check box functionality
     *
     */
    naSingleSelectCheck = (event, configuration) => {
        try {
			//const { itemResponses } = this.props;
            var itemKey = configuration.key;
            var naCheck = event.target.checked;
            var surveyItem = document.getElementById(`survey-item-block_${itemKey}`);
            this.setState({naCheck:naCheck});

            if (naCheck) {
                surveyItem.style.background = "#F2F2F2";
                surveyItem.style.color = "#ACACAC";
				var responseSet = (this.props.itemResponses[itemKey] = {});
				var itemResponses = [
					{
						itemType: configuration.itemType,
						buttonGroup: null,
						sequence: 1,
						isNa: naCheck,
						response: null,
						responseValue: null,
						openEnd: null,
						serverStatus: 0,
						hasPosted: 0,
					},
				];

                processItemResponse(itemKey, responseSet, itemResponses);
				this.props.handleItemResponse(
					configuration.key,
					this.props.itemResponses,
					"itemChange"
				);
            } else {
                surveyItem.style.background = "#fff";
                surveyItem.style.color = "#000";
            }

            this.resetAllSingleItem(null, configuration, null, naCheck);
        } catch (error) {
			console.log(
				"Exception: while check n/a checkbox in single select:_",
				error
			);
        }
	};

    /**
     * Restore value before selected
     *
     */
    resetSingleSelectResponse = (event, configuration) => {
        const { dispatch } = this.props;
        const layOutHints = configuration.layoutHints;
        var sliderRestoreValue = this.restoreSingleItemArr[0].responseValue;

        if (layOutHints === "slider") {
			dispatch(resetSingleItemSlider(sliderRestoreValue));
        }
        this.resetAllSingleItem(null, configuration, null, "reset");
	};

      renderView = (configuration, rateeKey) => {
		const { questionItemList, pageInstrumentConfiguration, itemResponses, dataCollectionGuid, itemTempResponses, dependencies, pageList, pageNumber, activePageKey, survey, assessmentInfosForDataCollection, horizontalAlignment, nextPageKey } = this.props;
    const { scales } = pageInstrumentConfiguration;
    const scaleResponses = scales[configuration.scaleKey].scaleResponses;
    const renderingHint = scales[configuration.scaleKey].renderingHint;
		const selectionPromptPlaceholder = scales[configuration.scaleKey].selectionPromptPlaceholder;
		const selectionPrompt= scales[configuration.scaleKey].selectionPrompt;		;
    const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];
	
    if (renderingHint == "dropdown") {
		return <SingleSelectDropDown
                itemKey={scales[configuration.scaleKey].key}
                singleSelectItemConfiguration={scales[configuration.scaleKey]}
                className={scales[configuration.scaleKey].className}
                configuration={scaleResponses}
                buttonGroup={configuration.key}
                dependencies={dependencies}
                pageList={pageList}
                survey={survey}
                activePageKey={activePageKey}
                pageNumber={pageNumber}
                items={configuration}
                itemResponses={itemResponses}
                itemTempResponses={itemTempResponses}
                handleItemResponse={(itemKey, itemResponsesSet, type, dataGuidId) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuidId)}
                questionItemList={questionItemList}
                ratees={assessmentObj}
				nextPageKey={nextPageKey}
                rateeKey={dataCollectionGuid}
                putAllForItemCollection={this.props.putAllForItemCollection}
				handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
				getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
            />
	} else if (renderingHint == "captcha") {
		return <SingleSelectImageResponse
					itemKey={scales[configuration.scaleKey].key}
					singleSelectImageItemConfiguration={scales[configuration.scaleKey]}
					className={scales[configuration.scaleKey].className}
					configuration={scaleResponses}
					buttonGroup={configuration.key}
					dependencies={dependencies}
					items={configuration}
					itemResponses={itemResponses}
					itemTempResponses={itemTempResponses}
					onNextButtonClickTest={(num, type, activePageNumber) =>
						this.props.onNextButtonClick(num, type, activePageNumber)
					}
					handleItemResponse={(itemKey, itemResponsesSet, type, dataGuidId) =>
						this.props.handleItemResponse(
							itemKey,
							itemResponsesSet,
							type,
							dataGuidId
						)
					}
					pageList={pageList}
					survey={survey}
					activePageKey={activePageKey}
					pageNumber={pageNumber}
					questionItemList={questionItemList}
					ratees={assessmentObj}
					rateeKey={dataCollectionGuid}
					horizontalAlignment={horizontalAlignment}
					putAllForItemCollection={this.props.putAllForItemCollection}
            />

		} else if(renderingHint == "tiles"){
				return <SingleSelectTilesResponse
					itemKey={scales[configuration.scaleKey].key}
					singleSelectItemConfiguration={scales[configuration.scaleKey]}
					className={scales[configuration.scaleKey].className}
					configuration={scaleResponses}
					buttonGroup={configuration.key}
					dependencies={dependencies}
					pageList={pageList}
					survey={survey}
					activePageKey={activePageKey}
					pageNumber={pageNumber}
					items={configuration}
					itemResponses={itemResponses}
					itemTempResponses={itemTempResponses}
					handleItemResponse={(itemKey, itemResponsesSet, type, dataGuidId) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuidId)}
					questionItemList={questionItemList}
					ratees={assessmentObj}
					selectionPromptPlaceholder={selectionPromptPlaceholder}
					selectionPrompt={selectionPrompt}
					nextPageKey={nextPageKey}
					rateeKey={dataCollectionGuid}
					putAllForItemCollection={this.props.putAllForItemCollection}
					handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
					getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
					handleDynamicDependency={(checkboxAnswer,depKey,response,pageDep, reqInd)=>this.props.handleDynamicDependency(checkboxAnswer,depKey,response,pageDep, reqInd)}
				/>
	} else {
		return scaleResponses.map((responseConfiguration, i) => {
            return <SingleSelectResponse
                        key={responseConfiguration.key}
                        itemKey={scales[configuration.scaleKey].key}
                        singleSelectItemConfiguration={scales[configuration.scaleKey]}
                        className={scales[configuration.scaleKey].className}
                        configuration={responseConfiguration}
                        pageList={pageList}
                        survey={survey}
                        activePageKey={activePageKey}
                        pageNumber={pageNumber}
                        id={responseConfiguration.key}
                        buttonGroup={configuration.key}
                        items={configuration}
                        dependencies={dependencies}
                        itemResponses={itemResponses}
                        itemTempResponses={itemTempResponses}
                        onNextButtonClickTest={(num, type, activePageNumber) => this.props.onNextButtonClick(num, type, activePageNumber)}
                        handleItemResponse={(itemKey, itemResponsesSet, type, dataGuidId) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuidId)}
                        questionItemList={questionItemList}
                        indexKey={i}
					nextPageKey={nextPageKey}
                        ratees={assessmentObj}
                        rateeKey={dataCollectionGuid}
                        horizontalAlignment={horizontalAlignment}
                        putAllForItemCollection={this.props.putAllForItemCollection}
					handleDynamicDependency={(checkboxAnswer,depKey,response,pageDep, reqInd)=>this.props.handleDynamicDependency(checkboxAnswer,depKey,response,pageDep, reqInd)}
					getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
					handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
                />
        })
	}
}

    componentWillUnmount() {
        this.restoreSingleItemArr = [];
		window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    render() {
		const {
			configuration,
			questionItemList,
			pageInstrumentConfiguration,
			assessmentInfosForDataCollection,
		} = this.props;
		const {
			scales,
			itemNaUncheckedButtonKey,
			itemResetButtonKey,
			itemRestoreButtonKey,
			buttons,
			sections,
			properties,
		} = pageInstrumentConfiguration;
        var singleItemIcon = [];
        var scaleKey = configuration.scaleKey;
		const renderingHint = scales[configuration.scaleKey].renderingHint;
		const scaleResponses = scales[configuration.scaleKey].scaleResponses;
		const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        singleItemIcon = questionItemList.filter((item, i) => {
            if (item.key === configuration.key ) {
                return item.userResponse.length || 0;
            }
            return null;
        });

        var naResponse = scales[scaleKey].naResponse || null;
        // var rateeKey = ratees[0].key;
		var jsx = "";
        var rateeKey = null;

        for (const key in ratees) {
            if (ratees.hasOwnProperty(key)) {
                const element = ratees[key];
                rateeKey = element.key;
            }
        }
		var groupIconsClass =
			configuration.hasItemResetButton ||
				configuration.hasItemRestoreButton ||
				naResponse !== null
				? "ItemGroupIcon"
				: null;

		let OSName = "Unknown OS";
		if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
		if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
		if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
		if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
		if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";
        if (ratees.length < 2) {
            jsx = (
                <Fragment>
					<div
						// id={`survey-item-block_${configuration.key}`}
						// className={"survey-item-block"}
						data-id={configuration.key}
						name={`survey-item-block`}
						id={`survey-item-block_${configuration.key}`}
						className={`survey-item-block_${configuration.key}`}
						style={(isMobile || isTablet) && OSName == "Android" || "iOS" ? {position:'relative', top:0} : null}
					>
						<Row
							id={`ScrollDiv_${configuration.key}`}
							className={`_ItemTextCss ${configuration.cssClass !== null ? configuration.cssClass : ""
								}`}
						>
							{configuration.itemText && configuration.itemText !== null ? (
                                <>
                                    <Col xs={1}>
                                        <div className={"ItemSpinner"}>
                                            { this.renderSpinner(configuration) }
                                        </div>
                                    </Col>
                                    <Col
										xs={
											naResponse !== null &&
												naResponse !== undefined &&
												configuration.hasItemResetButton &&
												configuration.hasItemRestoreButton
												? 10
												: 10
										}
                                        className="itemText"
                                    >
										{configuration.isRequiredLabel === true ? (
											<span className={"_AsteriskMark"}>
												{properties.requiredIndicator}
											</span>
										) : (
											""
										)}
										<span
											className="itemTag"
											dangerouslySetInnerHTML={{
												__html: processResponse(configuration.itemTag),
											}}
										></span>
										<span
											dangerouslySetInnerHTML={{
												__html: processResponse(configuration.itemText),
											}}
										></span>
                                    </Col>
                                    <Col xs={1}></Col>
                                </>
							) : null}
							<Col
								xs={1}
								className={groupIconsClass}
								style={{
									display:
										naResponse !== null &&
											naResponse !== undefined &&
											configuration.hasItemResetButton &&
											configuration.hasItemRestoreButton
											? "block"
											: "none",
								}}
							>
								{naResponse !== null && naResponse !== undefined ? (
									<span>
                                    <Form.Check
                                        className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                                        type="checkbox"
											onChange={(event) =>
												this.naSingleSelectCheck(event, configuration)
											}
                                    />
                                    <span>{buttons[itemNaUncheckedButtonKey].buttonText}</span>
									</span>
								) : null}
								{configuration.hasItemResetButton ? (
									<span
                                    className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
										onClick={(event) =>
											this.resetAllSingleItem(
												event,
												configuration,
												rateeKey,
												"clear"
											)
										}
                                >
										{singleItemIcon.length > 0 &&
											this.state.undoIcon === false ? (
											<i
												className={
													buttons[itemResetButtonKey].buttonFontAwesome
                                    }
											></i>
										) : null}
									</span>
								) : null}
								{configuration.hasItemRestoreButton ? (
                                    <span
                                        className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
										onClick={(event) =>
											this.resetSingleSelectResponse(event, configuration)
										}
                                    >
										{this.state.undoIcon === true &&
											this.state.naCheck === false ? (
											<i
												className={
													buttons[itemRestoreButtonKey].buttonFontAwesome
                                    }
											></i>
										) : null}
									</span>
								) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={1}>
                                <div className={"ItemSpinner"}>
                                    { this.renderSpinner(configuration) }
                                </div>
                            </Col>
                            <Col xs={10}>
								{configuration.itemPreSectionKey !== null &&
									sections.hasOwnProperty(configuration.itemPreSectionKey) ? (
                                    <ItemSection
                                        key={sections[configuration.itemPreSectionKey].key}
                                        type="itemPreSection"
                                        html={sections[configuration.itemPreSectionKey].content}
										className={
											sections[configuration.itemPreSectionKey].className !==
												null
												? sections[configuration.itemPreSectionKey].className
												: ""
										}
									/>
								) : null}
                            </Col>
                            <Col xs={1}></Col>
                        </Row>
                        <Row key={configuration.key} className="_itemRenderBlock">
                            <Col xs={1}></Col>
							<Col
								xs={10}
								className={
									configuration.layoutHints === "slider"
										? "single-select-item-slider"
										: configuration.layoutHints === "radioHorizontal"
											? "single-select-item-radio-horizontal"
											: configuration.layoutHints === "singleBox"
												? "single-select-box-block"
												: `_LIS_Item ${configuration.cssClass !== null
													? configuration.cssClass
													: ""
												}`
                            }
							>
								{this.renderView(configuration, rateeKey)}
                            </Col>
                            <Col xs={1}></Col>
                        </Row>
                        <Row>
                            <Col xs={1}></Col>
                            <Col xs={10}>
								{configuration.itemPostSectionKey !== null &&
									sections.hasOwnProperty(configuration.itemPostSectionKey) ? (
                                    <ItemSection
                                        key={sections[configuration.itemPostSectionKey].key}
                                        type="itemPostSection"
                                        html={sections[configuration.itemPostSectionKey].content}
										className={
											sections[configuration.itemPostSectionKey].className !==
												null
												? sections[configuration.itemPostSectionKey].className
												: ""
										}
									/>
								) : null}
                            </Col>
                        </Row>
                    </div>
                </Fragment>
            );
        } else {
            jsx = (
				<div
					id={`survey-item-block_${configuration.key}`}
					className={"survey-item-block"}
				>
					<Row
						id={`ScrollDiv_${configuration.key}`}
						className={`_ItemTextCss ${configuration.cssClass !== null ? configuration.cssClass : ""
							}`}
					>
						{configuration.itemText && configuration.itemText !== null ? (
                                <>
                                    <Col xs={1}>
                                        <div className={"ItemSpinner"}>
                                            { this.renderSpinner(configuration) }
                                        </div>
                                    </Col>
                                    <Col
									xs={
										naResponse !== null &&
											naResponse !== undefined &&
											configuration.hasItemResetButton &&
											configuration.hasItemRestoreButton
											? 10
											: 10
									}
									className="itemText"
                                    >
									{configuration.isRequiredLabel === true ? (
										<span className={"_AsteriskMark"}>
											{properties.requiredIndicator}
										</span>
									) : (
										""
									)}
									<span
										className="itemTag"
										dangerouslySetInnerHTML={{
											__html: processResponse(configuration.itemTag),
										}}
									></span>
									<span
										dangerouslySetInnerHTML={{
											__html: processResponse(configuration.itemText),
										}}
									></span>
                                    </Col>
                                </>
						) : null}
						<Col
							xs={1}
							className={groupIconsClass}
							style={{
								display:
									naResponse !== null &&
										naResponse !== undefined &&
										configuration.hasItemResetButton &&
										configuration.hasItemRestoreButton
										? "block"
										: "none",
							}}
						>
							{naResponse !== null && naResponse !== undefined ? (
								<span>
                                    <Form.Check
                                        className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                                        type="checkbox"
										onChange={(event) =>
											this.naSingleSelectCheck(event, configuration)
										}
                                    />
                                    <span>{buttons[itemNaUncheckedButtonKey].buttonText}</span>
								</span>
							) : null}
							{configuration.hasItemResetButton ? (
								<span
                                    className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
									onClick={(event) =>
										this.resetAllSingleItem(
											event,
											configuration,
											rateeKey,
											"clear"
										)
                                    }
								>
									{singleItemIcon.length > 0 &&
										this.state.undoIcon === false ? (
										<i
											className={buttons[itemResetButtonKey].buttonFontAwesome}
										></i>
									) : null}
								</span>
							) : null}
							{configuration.hasItemRestoreButton ? (
                                    <span
                                        className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
									onClick={(event) =>
										this.resetSingleSelectResponse(event, configuration)
									}
                                    >
									{this.state.undoIcon === true &&
										this.state.naCheck === false ? (
										<i
											className={
												buttons[itemRestoreButtonKey].buttonFontAwesome
                                    }
										></i>
									) : null}
								</span>
							) : null}
                            </Col>
                        </Row>
					{configuration.isPlaceholder === true ? (
						<div className="PostItemTextDiv">This is placeholder</div>
					) : null}
					<div className="SingleSelectMultiUserGroup">

                        <table className="tableColumn">
                            <tbody>
								{this.state.width > 800 ? renderingHint !== "dropdown" ? <tr>
									<th className="_multiUserSingleSelectRateeNameTblCol"></th>
									{scaleResponses !== undefined && scaleResponses.map(
										(responseConfiguration) => {
											return (
												<th
													key={responseConfiguration.key}
													dangerouslySetInnerHTML={{
														__html:
															responseConfiguration.responseDescription,
													}}
													className="_multiUserSingleSelectTblCol"
												></th>
											);
									}
									)
                            }
								</tr>: null : null}
							</tbody>
							<tbody>
								{ratees.length > 0
									? ratees.map((ratee) => {
									return (
										<tr key={ratee.dataCollectionGuid}>
												<td
													key={ratee.key}
													className="_multiUserSingleSelectRateeNameTblCol"
													title={ratee.relationshipDescription}
												>
													{(ratee.participantFirstName !== null ? ratee.participantFirstName: "") +" "+ (ratee.participantLastName !== null ? ratee.participantLastName: "")}
                                                {/* {ratee.dataCollectionGuid} */}
											</td>
												{
													this.state.width > 800 ? renderingHint =="dropdown" ?  this.renderRangeSliderGroup(ratee, this): this.renderSingleSelectItem(ratee, this) :this.renderRangeSliderGroup(ratee, this)
												}
										</tr>
									);
									}, this)
									: null}
                            </tbody>

                        </table>
                    </div>
                </div>
            );
        }

        return jsx;
    }
}

const mapStateToProps = (state) => ({
    scrollToQuestionId:state.survey.scrollToQuestionId,
    answeredQuestionCount:state.survey.answeredQuestionCount,
	assessmentInfosForDataCollection: state.survey.assessmentInfoDataCollectionData,
});

export default connect(mapStateToProps)(SingleSelectItem);
